import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import ClientForm from "./ClientForm";
import InputCombo from "../../helpers/InputCombo";
import ClientReview from "./ClientReview";
import DialogServices from "./DialogServices";
import InputServicesMulti from "../../helpers/InputServicesMulti";
import ContractForm from "./ContractForm";
import ContractReview from "./ContractReview";



function ClientLocks(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   

        id:  defId,   

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 200,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    



        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

           // props.mainView.writeFilter('nazwa', '');
         

            setFilterParam({

                fak_kontrahenci_id:  defId,  

                          
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_home,client_locks', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



 

    


 




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
        filterClear();
        setTab(null); 
    }



    if(tab == null)
    {
        setTab([]);
        getTab();     
        return <div>
            ...
        </div>
    }





 
 

 

        document.title = "Historia blokad" ;



    return  <div className="view_content">

 
      


               <div className="bg_center">

                        <h3 className="dash_header">Historia blokad</h3>

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Data</td>                                                                                                                                    
                                                <td>Typ</td>                                                                                                                                                                                                                                                                 
                                                <td className="td_right">Opis</td>                                                                                                                            
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(row.stan_umowy == '2') rowStyle = rowStyle + " color_deleted ";

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td>{ix+1}</td>                                                          
                                                                <td className="gocenter"   >{row.created_at }</td>
                                                                <td className="gocenter"   >{row.typ }</td>
                                                                <td className=""   >{row.opis }</td>
                                                                
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>

               </div>
 
              

                              
           

    </div>
}


export default ClientLocks;